export const MAX_COMPARE = 4
